import React from "react";
import { Link } from "react-router-dom";

interface HeaderBottomProps {
  bClass?: string;
}

const HeaderBottom: React.FC<HeaderBottomProps> = ({ bClass }) => {
  const ClickHandler = (): void => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={`header-bottom-style ${bClass || ""}`}>
      <div className="wpo-site-header header-style-s3">
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-1 col-1">
                <div
                  id="navbar2"
                  className="site-navbar collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>

                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    {/* 🏠 Home */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/">
                        Home
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/home">
                            Wedding Home Style 1
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/home-2">
                            Wedding Home Style 2
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/home-3">
                            Wedding Home Style 3
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/home-4">
                            Wedding Planner Style 1
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/home-5">
                            Wedding Planner Style 2
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/home-6">
                            Wedding Shop Home
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/invitation">
                            Wedding Invitation
                          </Link>
                        </li>
                      </ul>
                    </li>

                    {/* 📄 Pages */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/">
                        Pages
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/about">
                            About
                          </Link>
                        </li>
                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/story">
                            Our Story
                          </Link>
                          <ul className="sub-menu">
                            <li>
                              <Link onClick={ClickHandler} to="/story">
                                Our Story Style 1
                              </Link>
                            </li>
                            <li>
                              <Link onClick={ClickHandler} to="/story-2">
                                Our Story Style 2
                              </Link>
                            </li>
                            <li>
                              <Link onClick={ClickHandler} to="/story-3">
                                Our Story Style 3
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/accomodation">
                            Accomodation
                          </Link>
                        </li>
                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/rsvp">
                            RSVP
                          </Link>
                          <ul className="sub-menu">
                            <li>
                              <Link onClick={ClickHandler} to="/rsvp">
                                RSVP Style 1
                              </Link>
                            </li>
                            <li>
                              <Link onClick={ClickHandler} to="/rsvp-2">
                                RSVP Style 2
                              </Link>
                            </li>
                            <li>
                              <Link onClick={ClickHandler} to="/rsvp-3">
                                RSVP Style 3
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/gallery">
                            Gallery
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/planner">
                            Planners
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/team-single/Annette-Black">
                            Planner Single
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/groom-bride">
                            Brides & Grooms
                          </Link>
                        </li>
                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/service">
                            Service
                          </Link>
                          <ul className="sub-menu">
                            <li>
                              <Link onClick={ClickHandler} to="/service">
                                Service
                              </Link>
                            </li>
                            <li>
                              <Link onClick={ClickHandler} to="/service-single/Wedding-Dress">
                                Service Single
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/pricing">
                            Pricing
                          </Link>
                        </li>
                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/">
                            Auth Pages
                          </Link>
                          <ul className="sub-menu">
                            <li>
                              <Link onClick={ClickHandler} to="/login">
                                Login
                              </Link>
                            </li>
                            <li>
                              <Link onClick={ClickHandler} to="/register">
                                Register
                              </Link>
                            </li>
                            <li>
                              <Link onClick={ClickHandler} to="/forgot">
                                Forgot Password
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/coming">
                            Coming Soon
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/404">
                            404 Error
                          </Link>
                        </li>
                      </ul>
                    </li>

                    {/* 💼 Portfolio */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/portfolio-grid">
                        Portfolio
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/portfolio-grid">
                            Portfolio Grid
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/portfolio-grid-s2">
                            Portfolio Grid S2
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/portfolio-slide">
                            Portfolio Slide
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/portfolio-masonary">
                            Portfolio Masonary
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="/project-single/James-Amelia"
                          >
                            Portfolio Single
                          </Link>
                        </li>
                      </ul>
                    </li>

                    {/* 🛍️ Shop */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/shop">
                        Shop
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/shop">
                            Shop
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="/product-single/Stylish-Designer-Gown"
                          >
                            Shop Single
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/cart">
                            Cart
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/wishlist">
                            Wishlist
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/checkout">
                            Checkout
                          </Link>
                        </li>
                      </ul>
                    </li>

                    {/* 📰 Blog */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/blog">
                        Blog
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/blog">
                            Blog Right Sidebar
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="/blog-left-sidebar"
                          >
                            Blog Left Sidebar
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/blog-fullwidth">
                            Blog Fullwidth
                          </Link>
                        </li>
                        <li className="menu-item-has-children">
                          <Link onClick={ClickHandler} to="/">
                            Blog Details
                          </Link>
                          <ul className="sub-menu">
                            <li>
                              <Link
                                onClick={ClickHandler}
                                to="/blog-single/You-Must-Need-a-Great-Photographer"
                              >
                                Blog Details Right Sidebar
                              </Link>
                            </li>
                            <li>
                              <Link
                                onClick={ClickHandler}
                                to="/blog-single-left-sidebar/you-must-need-a-great-photographer"
                              >
                                Blog Details Left Sidebar
                              </Link>
                            </li>
                            <li>
                              <Link
                                onClick={ClickHandler}
                                to="/blog-single-fullwidth/you-must-need-a-great-photographer"
                              >
                                Blog Details Fullwidth
                              </Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    {/* Contact */}
                    <li>
                      <Link onClick={ClickHandler} to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default HeaderBottom;
